import { get } from "../GenericServices";

const Supplier = {
  getSuppliersWithoutUser: (queryString) => {
    return get(`supplier/without-user?${queryString}`);
  },
  getSuppliers: (queryString) => {
    return get(`supplier?${queryString}`);
  },
};

export default Supplier;
